<template></template>

<script>
  import { mapActions } from 'vuex'

  let loaded = false

  export default {
    created () {
      if (loaded) {
        return
      }

      loaded = true
      this.retrieveNotifications()
      this.handlePusherEvents()
    },
    computed: {
      pusherPrivateUserChannel () {
        return `private-user.${this.$_notifications_config.getUserId()}`
      }
    },
    methods: {
      ...mapActions([
        'retrieveNotifications',
        'addNotification'
      ]),
      handlePusherEvents () {
        const channel = this.$pusher.subscribe(this.pusherPrivateUserChannel)

        channel.bind('Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', (notification) => {
          notification.readAt = null
          notification.createdAt = Date.now()
          this.addNotification(notification)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// notifications-loader.vue?23d5a58a